<div
  class="mb-4 flex flex-col gap-2"
  (click)="onContainerClick($event)">
  <div class="grid grid-cols-3 gap-6 py-2 pt-4">
    <app-filter-product-search
      [label]="isArabic() ? 'اسم الباقة' : 'Bundle Name'"
      [placeholder]="isArabic() ? 'ابحث باسم الباقة...' : 'Search by bundle name...'"
      [loading]="bundleSearchLoading()"
      [error]="bundleSearchError()"
      [results]="bundleSearchResults()"
      [(searchTerm)]="bundleSearchTerm"
      [(showDropdown)]="showBundleSearchDropdown"
      (searchChange)="onBundleSearchChange($event)"
      (selectItem)="onBundleSelect($event)"
      (inputFocus)="onBundleSearchFocus()"></app-filter-product-search>

    <app-filter-multi-select
      [label]="{ titleAr: 'الحالة', titleEn: 'Status' }"
      [placeholder]="{ titleAr: 'اختر الحالة', titleEn: 'Choose Status' }"
      [items]="statusOptions()"
      [selectedIds]="statusSelectedIds()"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="toggleStatus()"
      (selectionChange)="onStatusChange($event)"></app-filter-multi-select>

    <app-filter-multi-select
      [label]="{ titleAr: 'نوع الخصم', titleEn: 'Discount Type' }"
      [placeholder]="{ titleAr: 'اختر نوع الخصم', titleEn: 'Choose Discount Type' }"
      [items]="discountTypeOptions()"
      [selectedIds]="discountSelectedIds()"
      [showDropdown]="showDiscountDropdown()"
      (toggleDropdown)="toggleDiscount()"
      (selectionChange)="onDiscountTypeChange($event)"></app-filter-multi-select>

    <app-filter-date-component
      [label]="isArabic() ? 'بدأ في من' : 'Started On From'"
      [value]="filters().startDateFrom ?? null"
      (valueChange)="filters().startDateFrom = $event ?? undefined"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'بدأ في إلى' : 'Started On To'"
      [value]="filters().startDateTo ?? null"
      (valueChange)="filters().startDateTo = $event ?? undefined"
      [isInvalid]="startDateInvalid()"></app-filter-date-component>

    <div></div>

    <app-filter-date-component
      [label]="isArabic() ? 'ينتهي في من' : 'Ended On From'"
      [value]="filters().endDateFrom ?? null"
      (valueChange)="filters().endDateFrom = $event ?? undefined"></app-filter-date-component>

    <app-filter-date-component
      [label]="isArabic() ? 'ينتهي في إلى' : 'Ended On To'"
      [value]="filters().endDateTo ?? null"
      (valueChange)="filters().endDateTo = $event ?? undefined"
      [isInvalid]="endDateInvalid()"></app-filter-date-component>
  </div>

  @if (startDateInvalid()) {
    <p class="text-[12px] text-red-500">
      {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
    </p>
  }
  @if (endDateInvalid()) {
    <p class="text-[12px] text-red-500">
      {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية" : "From date cannot be after To date" }}
    </p>
  }
  <div class="mt-4 flex flex-col items-end justify-between gap-4 border-t border-gray-200 pt-4 md:flex-row">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="bundleSortOptions()"
      (toggleOrder)="toggleSortOrder.emit()"></app-filter-sorting-component>

    <div class="flex w-full justify-end gap-3 pb-1 md:w-auto">
      <button
        (click)="resetFilters.emit()"
        class="hoverBgPrimary10 borderTabsColor textTabsColor cursor-pointer rounded-[6px] border px-8 py-2.5 text-[13px] font-bold transition-colors">
        <ng-container i18n="@@stockfilter.reset">Clear</ng-container>
      </button>
      <button
        (click)="onApply()"
        [disabled]="startDateInvalid() || endDateInvalid()"
        class="bgTabsColor cursor-pointer rounded-[6px] px-10 py-2.5 text-[13px] font-bold text-white shadow-sm transition-all disabled:cursor-not-allowed disabled:opacity-50">
        <ng-container i18n="@@stock.apply">Apply</ng-container>
      </button>
    </div>
  </div>
</div>
